const __WEBPACK_NAMESPACE_OBJECT__ = require("@salesforce/commerce-sdk-react");